import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class SeuServicoDeBuscaService {
  constructor(private http: HttpClient) {}

  private openCageUrl = 'https://api.opencagedata.com/geocode/v1/json';
  // buscarEnderecoPorCep(cep: string): Observable<any> {
  //   // console.log(typeof cep)
  //   // console.log(cep)
  //   try{
  //   const apiUrl = `https://viacep.com.br/ws/${cep}/json/`;
  //   const resposta = this.http.get(apiUrl);
  //   console.log(resposta)
  //   // return this.http.get(apiUrl);
  //   return resposta;
  //   }catch{
  //   const confirmacao = window.confirm("CEP não encontrado!");
  //   return of(null);
  //   }
  // }

  buscarEnderecoPorCep(cep: string): Observable<any> {
    const apiUrl = `https://viacep.com.br/ws/${cep}/json/`;
    return this.http.get(apiUrl).pipe(
      catchError(error => {
        console.error('Erro ao buscar o CEP:', error);
        return of(null); // Retorna null em caso de erro
      })
    );
  }

  buscarCoordenadaPorCep(cep: string, chave: string): Observable<any> {
    const encodedCep = encodeURIComponent(cep);
    const geocodingApiUrl = `https://api.opencagedata.com/geocode/v1/json?q=${encodedCep}&key=${chave}`;

    return this.http.get(geocodingApiUrl);
  }

  buscarCoordenadasPorLogradouroEcidade(logradouro: string, cidade: string, chave:string): Observable<any> {
    // console.log(logradouro)
    // console.log(cidade)
    const encodedLogradouro = encodeURIComponent(logradouro);
    const encodedCidade = encodeURIComponent(cidade);    
    const geocodingApiUrl = `https://api.opencagedata.com/geocode/v1/json?q=${encodedLogradouro},${encodedCidade}&key=${chave}`;
    return this.http.get(geocodingApiUrl);
  }

  getAddress(latitude: number, longitude: number, chave: string): Observable<any> {
    const params = {
      key: chave,
      q: `${latitude},${longitude}`,
      no_annotations: 1 // Para não obter anotações
    };    
    return this.http.get<any>(this.openCageUrl, { params });
  }
}